import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const TrustQualitySection = () => {
  const trustPoints = [
    {
      id: 1,
      icon: 'Settings',
      title: 'OpenbooQ Controls the Process',
      description: 'From pricing to install, we manage every step to ensure consistency and quality'
    },
    {
      id: 2,
      icon: 'Users',
      title: 'Installers Work Under OpenbooQ Standards',
      description: 'All crews follow our standardized installation protocols and quality benchmarks'
    },
    {
      id: 3,
      icon: 'CheckCircle',
      title: 'Accountability Doesn\'t Disappear',
      description: 'We remain responsible after the contract is signed — not just before'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-br from-blue-900 via-slate-900 to-slate-800 text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
          className="space-y-16">
          
          {/* Header */}
          <motion.div variants={itemVariants} className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-jakarta font-bold leading-[1.1]">
              Trust, Quality &{' '}
              <span className="text-cyan-400">Accountability</span>
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed">
              This is not a race-to-the-bottom model. OpenbooQ maintains quality through centralized control and standardized processes.
            </p>
          </motion.div>

          {/* Trust Points */}
          <motion.div 
            variants={containerVariants}
            className="grid md:grid-cols-3 gap-8">
            {trustPoints?.map((point) => (
              <motion.div
                key={point?.id}
                variants={itemVariants}
                whileHover={{ y: -8 }}
                className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-cyan-400/50 hover:bg-white/10 transition-all duration-300">
                <div className="w-16 h-16 bg-cyan-500/20 rounded-2xl flex items-center justify-center mb-6">
                  <Icon name={point?.icon} size={32} className="text-cyan-400" />
                </div>
                <h3 className="text-2xl font-jakarta font-bold mb-4">
                  {point?.title}
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  {point?.description}
                </p>
              </motion.div>
            ))}
          </motion.div>

          {/* Bottom Statement */}
          <motion.div 
            variants={itemVariants}
            className="max-w-2xl mx-auto text-center bg-cyan-500/10 border border-cyan-400/30 rounded-2xl p-8">
            <p className="text-2xl font-jakarta font-semibold">
              Quality roofing without the overhead — that's the OpenbooQ difference.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustQualitySection;